import { FaBars } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { social } from '../../utils/constants';
import { userlinks } from '../../utils/userlinks';
import logo from '../../assets/MullaLogo.jpg';
import { useGlobalContext } from '../../context/GlobalContext';

const UserNavbar = () => {
  const { toggleSidebar, isLoggedIn, logoutUser } = useGlobalContext();
  console.log(isLoggedIn);
  return (
    <NavContainer>
      <div className='nav-center'>
        <div className='nav-header'>
          <Link to='/'>
            <img src={logo} alt='MullaLogo' className='logo' />
          </Link>
          <button type='button' className='nav-toggle' onClick={toggleSidebar}>
            <FaBars />
          </button>
          <ul className='social-icons'>
            {social.map((socialIcon) => {
              const { id, url, icon } = socialIcon;
              return (
                <li key={id}>
                  <a href={url}>{icon}</a>
                </li>
              );
            })}
          </ul>
        </div>

        <ul className='nav-links'>
          {userlinks.map((link) => {
            const { id, text, path } = link;
            return (
              <li key={id}>
                <Link to={path}>{text}</Link>
              </li>
            );
          })}
        </ul>
        {/* <div className='login'>
          {/* <Link to='/register' className='nav-links signup-link'>
            Sign up
          </Link> }
          {!isLoggedIn ? (
            <button className='btn-primary btn-login'>
              <Link to='/register'>Login</Link>
            </button>
          ) : (
            <button className='btn-primary btn-login' onClick={logoutUser}>
              <Link to='/'>Logout</Link>
            </button>
          )}
        </div> */}
      </div>
    </NavContainer>
  );
};

const NavContainer = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primaryNavColor);
  .nav-center {
    width: 100%;
    margin: 0 auto;
    max-width: var(--max-width);
  }
  .nav-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 5rem;
  }
  .nav-toggle {
    background: white;
    border-color: transparent;
    color: var(--primaryBtnColor);
    transition: var(--transition);
    cursor: pointer;
    margin-right: 5rem;
    svg {
      font-size: 2rem;
    }
  }

  .nav-toggle:hover {
    color: var(--primaryTxtColor);
  }

  .nav-links {
    display: none;
    color: var(--primaryTxtColor);
  }

  .logo {
    margin-left: 15px;
    justify-self: center;
    height: 5rem;
    width: 175px;
  }
  .cart-btn-wrapper {
    display: none;
  }

  .social-icons {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 0;
    margin-top: 1rem;
    margin-right: 1rem;
  }

  .social-icons a {
    margin: 0 0.5rem;
    color: var(--primaryBtnColor);
    transition: var(--transition);
  }

  .social-icons a:hover {
    color: var(--primaryTxtColor);
  }

  .btn-login {
    margin-right: 10rem;
    display: none;
  }

  .login {
    display: flex;
    flex-direction: row;
    vertical-align: middle;
  }

  @media (min-width: 992px) {
    .nav-toggle {
      display: none;
    }
    .nav-center {
      display: grid;
      grid-template-columns: auto 1fr auto;
      align-items: center;
    }
    .nav-links {
      display: flex;
      justify-content: center;
      li {
        margin: 0 0.5rem;
      }
      a {
        color: var(--clr-grey-3);
        font-size: 1rem;
        text-transform: capitalize;
        letter-spacing: var(--spacing);
        padding: 0.5rem;
        &:hover {
          border-bottom: 2px solid var(--clr-primary-7);
        }
      }
    }
    .cart-btn-wrapper {
      display: grid;
    }
    .social-icons {
      justify-content: flex-end;
      flex-direction: column;
      position: absolute;
      right: 0;
    }
    .btn-login {
      display: flex;
      margin-right: 4rem;
    }

    .signup-link {
      display: flex;
      margin-right: 2rem;
      align-items: center;
      justify-content: center;
    }
  }
`;
export default UserNavbar;
